import { Injectable } from "@angular/core";
import { CanDeactivate } from "@angular/router";
import { Router } from "@angular/router";
import { Store } from "@ngrx/store";
@Injectable()
export class ClearSearchGuard implements CanDeactivate<any> {
  constructor(private store: Store<any>) {}

  canDeactivate() {
    this.store.dispatch({ type: "CLEAR_SEARCH" });
    return true;
  }
}



// WEBPACK FOOTER //
// /Users/maxsheikhizadeh/Desktop/GEN/physician-portal/src/app/shared/guard/clear-search.guard.ts